import React, { ReactElement } from 'react';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';
import ForbiddenPage from '../../../page/ForbiddenPage/ForbiddenPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';

interface Props {
  pouzivatel: CurrentUserDetail;
  children: ReactElement;
  allowForRoles?: Array<UserRoleEnum>;
  additionalCheck?: boolean;
}

const isAuthorized = (
  allowForRoles: Array<UserRoleEnum>,
  user: CurrentUserDetail,
): boolean => {
  const userRoles = user == null ? [] : user.roles;
  if (!allowForRoles) {
    return true;
  }
  if (!userRoles || userRoles.length === 0 || allowForRoles.length === 0) {
    return false;
  }
  return userRoles.some(role => allowForRoles.includes(role));
};

const SecuredPageComponent = ({
  children,
  allowForRoles,
  pouzivatel,
  additionalCheck = true,
}: Props): ReactElement => {
  if (!isAuthorized(allowForRoles, pouzivatel) || !additionalCheck) {
    return <ForbiddenPage />;
  }

  return children;
};

export default SecuredPageComponent;
